/**
 * Element id for the table region whose width drives highlight relayout
 * (ResizeObserver on the controller). Must match the DOM used by the table
 * grid / resizer; kept in `@databases/highlights` so consumers only call
 * `createLayer` / `mount` without importing this string.
 */
export const TABLE_HIGHLIGHTS_RESIZE_OBSERVE_ELEMENT_ID = 'resizeObserver';
